import { ErrorResponse } from '@gtpl/shared-models/common-models';
import { Injectable, Post } from '@nestjs/common';
import { InjectRepository } from '@nestjs/typeorm';
import { count } from 'rxjs/operators';
import { getConnection, In, Like, MoreThan, Not, Raw, Repository } from 'typeorm';
import { BenefitsEntity } from './benefits.entity';
import { BenefitXRefEntity } from './benefitsxref.entity';
import { AllResponseModel, SingleResponseModel } from './dto/incharge-response-model';
import { ChildInchargeDto, InchargeDTO, PaginationDto, TransformDto } from './dto/incharge.dto';
import { InchargeEntity } from './incharge.entity';
import { InchargeXRefEntity } from './inchargexref.entity';
import { MandalListEntity } from './mandal.entity';
import { VillageListEntity } from './village.entity';
import { InchargeBoothXRefEntity } from './boothinchargexref.entity';
import { UserEntity } from '../user/user.entity';

@Injectable()
export class InchargeService {
    constructor (
        @InjectRepository(MandalListEntity)
        private mandalRepo: Repository<MandalListEntity>,
        @InjectRepository(VillageListEntity)
        private villRepo: Repository<VillageListEntity>,
        @InjectRepository(BenefitsEntity)
        private benftRepo: Repository<BenefitsEntity>,
        @InjectRepository(BenefitXRefEntity)
        private benftxrfRepo: Repository<BenefitXRefEntity>,
        @InjectRepository(InchargeEntity)
        private inchrgRepo: Repository<InchargeEntity>,
        @InjectRepository(InchargeXRefEntity)
        private inchrgxrfRepo: Repository<InchargeXRefEntity>,
        @InjectRepository(InchargeBoothXRefEntity)
        private bothinchrgXRepo: Repository<InchargeBoothXRefEntity>,
        @InjectRepository(UserEntity)
        private useRepo: Repository<UserEntity>,
    ) {}


    async getMandals(queryParams, request:Request): Promise<AllResponseModel> {
        const response = new AllResponseModel();
        try {
            if(queryParams.apiVersion == 1) {
                const villist = await this.mandalRepo.find({
                    order: {Id: 'ASC'}
                });

                if(villist) {
                    const final = villist.map((f) => {
                        return {
                            Id:f.Id,
                            MandalName:f.MandalName
                        }
                    });
                    response.status = true;
                    response.data = final;
                    response.statusCode = 50000;
                    response.internalMessage = 'Data retrieved successfully';
                    response.intlCode = 11108;
                } else {
                    throw new ErrorResponse(99998, 'Data not found');
                }
                            
            } else {
                const villist = await this.mandalRepo.find({
                    order: {Id: 'ASC'}
                });

                if(villist) {
                    const final = villist.map((f) => {
                        return {
                            Id:f.Id,
                            MandalName:f.MandalName
                        }
                    });
                    response.status = true;
                    response.data = final;
                    response.statusCode = 50000;
                    response.internalMessage = 'Data retrieved successfully';
                    response.intlCode = 11108;
                } else {
                    throw new ErrorResponse(99998, 'Data not found');
                }
                            
            }
            return response;
        } catch (error) {
            throw error;
        }
    }


    async getVillages(queryParams,Mandalid, request:Request): Promise<AllResponseModel> {
        const response = new AllResponseModel();
        try {
            if(queryParams.apiVersion == 1) {
                const villist = await this.villRepo.find({
                    where:[{Mandalid:Mandalid}],
                    order: {Id: 'ASC'}
                });

                if(villist) {
                    const final = villist.map((f) => {
                        return {
                            Id:f.Id,
                            Village_Name:f.Village_Name
                        }
                    });
                    response.status = true;
                    response.data = final;
                    response.statusCode = 50000;
                    response.internalMessage = 'Data retrieved successfully';
                    response.intlCode = 11108;
                } else {
                    throw new ErrorResponse(99998, 'Data not found');
                }
                            
            } else {
                const villist = await this.villRepo.find({
                    where:[{Mandalid:Mandalid}],
                    order: {Id: 'ASC'}
                });

                if(villist) {
                    const final = villist.map((f) => {
                        return {
                            Id:f.Id,
                            Village_Name:f.Village_Name
                        }
                    });
                    response.status = true;
                    response.data = final;
                    response.statusCode = 50000;
                    response.internalMessage = 'Data retrieved successfully';
                    response.intlCode = 11108;
                } else {
                    throw new ErrorResponse(99998, 'Data not found');
                }
                            
            }
            return response;
        } catch (error) {
            throw error;
        }
    }


    async getBenefits(queryParams, request:Request): Promise<AllResponseModel> {
        const response = new AllResponseModel();
        try {
            if(queryParams.apiVersion == 1) {
                const beniftlist = await this.benftRepo.find({
                    order: {Id: 'ASC'}
                });

                if(beniftlist) {
                    const final = beniftlist.map((f) => {
                        return {
                            Id:f.Id,
                            benefits:f.benefits
                        }
                    });
                    response.status = true;
                    response.data = final;
                    response.statusCode = 50000;
                    response.internalMessage = 'Data retrieved successfully';
                    response.intlCode = 11108;
                } else {
                    throw new ErrorResponse(99998, 'Data not found');
                }
                            
            } else {
                const beniftlist = await this.benftRepo.find({
                    order: {Id: 'ASC'}
                });

                if(beniftlist) {
                    const final = beniftlist.map((f) => {
                        return {
                            Id:f.Id,
                            benefits:f.benefits
                        }
                    });
                    response.status = true;
                    response.data = final;
                    response.statusCode = 50000;
                    response.internalMessage = 'Data retrieved successfully';
                    response.intlCode = 11108;
                } else {
                    throw new ErrorResponse(99998, 'Data not found');
                }
                            
            }
            return response;
        } catch (error) {
            throw error;
        }
    }
    

    async getIncharges(queryParams, request:Request): Promise<AllResponseModel> {
        const response = new AllResponseModel();
        try {
            const finData: any[] = [];
            if(queryParams.apiVersion == 1) {
                const inchrglist = await this.inchrgRepo.find({
                    where: [{BoothNo: Like(`%${queryParams.searchTerm}`)},
                    {SerialNo: Like(`%${queryParams.searchTerm}`)},
                    {VillageID: Like(`%${queryParams.searchTerm}`)},
                    {Caste: Like(`%${queryParams.searchTerm}`)},
                    {GENDER: Like(`%${queryParams.searchTerm}`)} ],
                    order: {Id: 'ASC'}
                });

                if(inchrglist) {
                    const promises = inchrglist.map(async (f) => {
                        var villnm = '';
                        var chldcnt = 0;
                        const vill = await this.villRepo.findOne({
                            where:[{Id:f.VillageID}]
                        });
                        if(vill) {
                            villnm = vill.Village_Name;
                        }
                        const chlds = await this.inchrgxrfRepo.find({
                            where:[{InchargeID:f.Id}]
                        })
                        if(chlds) {
                            chldcnt = chlds.length;
                        }
                        return {
                            Id:f.Id,
                            FirstName:f.FirstName,
                            Surname:f.Surname,
                            FullName: f.FirstName+f.Surname,
                            BoothNo:f.BoothNo,
                            VillageName:villnm,
                            ChildsCount: chldcnt
                        }
                    });
                    const da = await Promise.all(promises);
                    da.map((f) => { 
                        finData.push({
                            Id:f.Id,
                            FirstName:f.FirstName,
                            Surname:f.Surname,
                            FullName: f.FirstName+f.Surname,
                            Booth:f.BoothNo,
                            VillageName:f.VillageName,
                            ChildsCount: f.ChildsCount
                        })
                    });
                    response.status = true;
                    response.data = finData;
                    response.statusCode = 50000;
                    response.internalMessage = 'Data retrieved successfully';
                    response.intlCode = 11108;
                } else {
                    throw new ErrorResponse(99998, 'Data not found');
                }
                            
            } else {
                const inchrglist = await this.inchrgRepo.find({
                    where: [{BoothNo: Like(`%${queryParams.searchTerm}`)},
                    {SerialNo: Like(`%${queryParams.searchTerm}`)},
                    {VillageID: Like(`%${queryParams.searchTerm}`)},
                    {Caste: Like(`%${queryParams.searchTerm}`)},
                    {GENDER: Like(`%${queryParams.searchTerm}`)} ],
                    order: {Id: 'ASC'}
                });

                if(inchrglist) {
                    const promises = inchrglist.map(async (f) => {
                        var villnm = '';
                        var chldcnt = 0;
                        const vill = await this.villRepo.findOne({
                            where:[{Id:f.VillageID}]
                        });
                        if(vill) {
                            villnm = vill.Village_Name;
                        }
                        const chlds = await this.inchrgxrfRepo.find({
                            where:[{InchargeID:f.Id}]
                        })
                        if(chlds) {
                            chldcnt = chlds.length;
                        }
                        return {
                            Id:f.Id,
                            FirstName:f.FirstName,
                            Surname:f.Surname,
                            FullName: f.FirstName+f.Surname,
                            BoothNo:f.BoothNo,
                            VillageName:villnm,
                            ChildsCount: chldcnt
                        }
                    });
                    const da = await Promise.all(promises);
                    da.map((f) => { 
                        finData.push({
                            Id:f.Id,
                            FirstName:f.FirstName,
                            Surname:f.Surname,
                            FullName: f.FirstName+f.Surname,
                            Booth:f.BoothNo,
                            VillageName:f.VillageName,
                            ChildsCount: f.ChildsCount
                        })
                    });
                    response.status = true;
                    response.data = finData;
                    response.statusCode = 50000;
                    response.internalMessage = 'Data retrieved successfully';
                    response.intlCode = 11108;
                } else {
                    throw new ErrorResponse(99998, 'Data not found');
                }
                            
            }
            return response;
        } catch (error) {
            throw error;
        }
    }

    async addIncharge(queryParams,imgpath,inchdto:InchargeDTO,request:Request): Promise<SingleResponseModel> {
        const response = new SingleResponseModel();
        try {
            inchdto.ImageLocation = imgpath.length > 0 ? imgpath[0] : '';
            //if(inchdto.InchargeID) {
                const chkinchrg = await this.bothinchrgXRepo.findOne({
                    where:{InchargeBoothID:inchdto.BoothNo, InchargeUserID:inchdto.InchargeID}
                });
            //}
            var useRole = await this.useRepo.findOne({
                where:{Id:inchdto.Createdby}
            })
            if(chkinchrg || (useRole && (useRole.roleId == 1 || useRole.roleId == 2))) {
                if(queryParams.apiVersion == 1) {
                    let sadata = {
                        BoothNo:inchdto.BoothNo,
                        SerialNo: inchdto.SerialNo,
                        HNo: inchdto.HNo,
                        FirstName: inchdto.FirstName,
                        Surname: inchdto.Surname,
                        FNTG: inchdto.FNTG,
                        SNTG: inchdto.SNTG,
                        FH: inchdto.FH,
                        FHName: inchdto.FHName,
                        VoterID: inchdto.VoterID,
                        GENDER: inchdto.GENDER,
                        AGE: inchdto.AGE,
                        DOB: inchdto.DOB,
                        VillageID: inchdto.VillageID,
                        Caste: inchdto.Caste,
                        LocalNonLocal: inchdto.LocalNonLocal,
                        NL_Remarks: inchdto.NL_Remarks,
                        MOBILE_NO: inchdto.MOBILE_NO,
                        RequestedSchemes: inchdto.RequestedSchemes,
                        Party:inchdto.Party,
                        Remarks:inchdto.Remarks,
                        FamilyCount: inchdto.FamilyCount,
                        InchargeUserid: inchdto.InchargeUserid,
                        GeoLocation: inchdto.GeoLocation,
                        IsHOH:inchdto.IsHOH,
                        ImageLocation: inchdto.ImageLocation
                    }
                    const inchrg = await this.inchrgRepo.save(sadata);
    
                    if(inchrg) {
                        if(inchdto.BenefitsIDs) {
                            var benxref = inchdto.BenefitsIDs.split(',').map(async (el) => {
                                await this.benftxrfRepo.save({
                                    BenefitsID: parseInt(el),
                                    InchargeID: inchrg.Id
                                });
                            });                        
                        }
                        
                        if(inchdto.InchargeID) {
                            var incxref = {
                                InchargeID: inchdto.InchargeID,
                                InchargeChID: inchrg.Id,
                                Createdby:inchdto.Createdby
                            }
        
                            const inref = await this.inchrgxrfRepo.save(incxref);
                        }                   
                        
                        response.status = true;
                        response.data = inchrg;
                        response.statusCode = 50000;
                        response.internalMessage = 'Data saved successfully';
                        response.intlCode = 11108;
                    } else {
                        throw new ErrorResponse(99998, 'Failed to save');
                    }
                                
                } else {
                    let sadata = {
                        BoothNo:inchdto.BoothNo,
                        SerialNo: inchdto.SerialNo,
                        HNo: inchdto.HNo,
                        FirstName: inchdto.FirstName,
                        Surname: inchdto.Surname,
                        FNTG: inchdto.FNTG,
                        SNTG: inchdto.SNTG,
                        FH: inchdto.FH,
                        FHName: inchdto.FHName,
                        VoterID: inchdto.VoterID,
                        GENDER: inchdto.GENDER,
                        AGE: inchdto.AGE,
                        DOB: inchdto.DOB,
                        VillageID: inchdto.VillageID,
                        Caste: inchdto.Caste,
                        LocalNonLocal: inchdto.LocalNonLocal,
                        NL_Remarks: inchdto.NL_Remarks,
                        MOBILE_NO: inchdto.MOBILE_NO,
                        RequestedSchemes: inchdto.RequestedSchemes,
                        Party:inchdto.Party,
                        Remarks:inchdto.Remarks,
                        FamilyCount: inchdto.FamilyCount,
                        InchargeUserid: inchdto.InchargeUserid,
                        GeoLocation: inchdto.GeoLocation,
                        IsHOH:inchdto.IsHOH,
                        ImageLocation: inchdto.ImageLocation
                    }
                    const inchrg = await this.inchrgRepo.save(sadata);
    
                    if(inchrg) {
                        if(inchdto.BenefitsIDs) {
                            var benxref = inchdto.BenefitsIDs.split(',').map(async (el) => {
                                await this.benftxrfRepo.save({
                                    BenefitsID: parseInt(el),
                                    InchargeID: inchrg.Id
                                });
                            });                        
                        }
                        
                        if(inchdto.InchargeID) {
                            var incxref = {
                                InchargeID: inchdto.InchargeID,
                                InchargeChID: inchrg.Id,
                                Createdby:inchdto.Createdby
                            }
        
                            const inref = await this.inchrgxrfRepo.save(incxref);
                        }                   
                        
                        response.status = true;
                        response.data = inchrg;
                        response.statusCode = 50000;
                        response.internalMessage = 'Data saved successfully';
                        response.intlCode = 11108;
                    } else {
                        throw new ErrorResponse(99998, 'Failed to save');
                    }
                                
                }
            } else {
                throw new ErrorResponse(99998, 'BoothNo not assigned to this Incharge');
            }           
            return response;
        } catch (error) {
            throw error;
        }
    }

    async editIncharge(queryParams,imgpath,inchdto:InchargeDTO,request:Request): Promise<SingleResponseModel> {
        const response = new SingleResponseModel();
        try {
            
            const chkinchrg = await this.bothinchrgXRepo.findOne({
                where:{InchargeBoothID:inchdto.BoothNo, InchargeUserID:inchdto.InchargeID}
            }); 
            var useRole = await this.useRepo.findOne({
                where:{Id:inchdto.UpdatedBy}
            })
            if(chkinchrg || (useRole && (useRole.roleId == 1 || useRole.roleId == 2))) {
                const oldData = await this.inchrgRepo.findOne({
                    where:{Id:inchdto.Id}
                });

                inchdto.ImageLocation = imgpath.length > 0 ? imgpath[0] : oldData.ImageLocation;

                if(inchdto.BoothNo) {
                    inchdto.BoothNo = inchdto.BoothNo
                } else {
                    inchdto.BoothNo = oldData.BoothNo
                }

                if(inchdto.SerialNo) {
                    inchdto.SerialNo = inchdto.SerialNo
                } else {
                    inchdto.SerialNo = oldData.SerialNo
                }

                if(inchdto.HNo) {
                    inchdto.HNo = inchdto.HNo
                } else {
                    inchdto.HNo = oldData.HNo
                }

                if(inchdto.FirstName) {
                    inchdto.FirstName = inchdto.FirstName
                } else {
                    inchdto.FirstName = oldData.FirstName
                }


                if(inchdto.Surname) {
                    inchdto.Surname = inchdto.Surname
                } else {
                    inchdto.Surname = oldData.Surname
                }

                if(inchdto.FNTG) {
                    inchdto.FNTG = inchdto.FNTG
                } else {
                    inchdto.FNTG = oldData.FNTG
                }

                if(inchdto.SNTG) {
                    inchdto.SNTG = inchdto.SNTG
                } else {
                    inchdto.SNTG = oldData.SNTG
                }

                if(inchdto.FH) {
                    inchdto.FH = inchdto.FH
                } else {
                    inchdto.FH = oldData.FH
                }

                if(inchdto.FHName) {
                    inchdto.FHName = inchdto.FHName
                } else {
                    inchdto.FHName = oldData.FHName
                }

                if(inchdto.VoterID) {
                    inchdto.VoterID = inchdto.VoterID
                } else {
                    inchdto.VoterID = oldData.VoterID
                }

                if(inchdto.GENDER) {
                    inchdto.GENDER = inchdto.GENDER
                } else {
                    inchdto.GENDER = oldData.GENDER
                }

                if(inchdto.AGE) {
                    inchdto.AGE = inchdto.AGE
                } else {
                    inchdto.AGE = oldData.AGE
                }

                if(inchdto.DOB) {
                    inchdto.DOB = inchdto.DOB
                } else {
                    inchdto.DOB = oldData.DOB
                }

                if(inchdto.VillageID) {
                    inchdto.VillageID = inchdto.VillageID
                } else {
                    inchdto.VillageID = oldData.VillageID
                }

                if(inchdto.Caste) {
                    inchdto.Caste = inchdto.Caste
                } else {
                    inchdto.Caste = oldData.Caste
                }

                if(inchdto.LocalNonLocal) {
                    inchdto.LocalNonLocal = inchdto.LocalNonLocal
                } else {
                    inchdto.LocalNonLocal = oldData.LocalNonLocal
                }

                if(inchdto.NL_Remarks) {
                    inchdto.NL_Remarks = inchdto.NL_Remarks
                } else {
                    inchdto.NL_Remarks = oldData.NL_Remarks
                }

                if(inchdto.MOBILE_NO) {
                    inchdto.MOBILE_NO = inchdto.MOBILE_NO
                } else {
                    inchdto.MOBILE_NO = oldData.MOBILE_NO
                }

                if(inchdto.RequestedSchemes) {
                    inchdto.RequestedSchemes = inchdto.RequestedSchemes
                } else {
                    inchdto.RequestedSchemes = oldData.RequestedSchemes
                }

                if(inchdto.Party) {
                    inchdto.Party = inchdto.Party
                } else {
                    inchdto.Party = oldData.Party
                }

                if(inchdto.Remarks) {
                    inchdto.Remarks = inchdto.Remarks
                } else {
                    inchdto.Remarks = oldData.Remarks
                }

                if(inchdto.FamilyCount) {
                    inchdto.FamilyCount = inchdto.FamilyCount
                } else {
                    inchdto.FamilyCount = oldData.FamilyCount
                }

                if(inchdto.InchargeUserid) {
                    inchdto.InchargeUserid = inchdto.InchargeUserid
                } else {
                    inchdto.InchargeUserid = oldData.InchargeUserid
                }

                if(inchdto.UpdatedBy) {
                    inchdto.UpdatedBy = inchdto.UpdatedBy;
                } else {
                    inchdto.UpdatedBy = oldData.UpdatedBy
                }

                if(inchdto.GeoLocation) {
                    inchdto.GeoLocation = inchdto.GeoLocation;
                } else {
                    inchdto.GeoLocation = oldData.GeoLocation;
                }  

                if(inchdto.IsHOH) {
                    inchdto.IsHOH = inchdto.IsHOH;
                } else {
                    inchdto.IsHOH = oldData.IsHOH;
                }

                let sadata = {
                    BoothNo:inchdto.BoothNo,
                    SerialNo: inchdto.SerialNo,
                    HNo: inchdto.HNo,
                    FirstName: inchdto.FirstName,
                    Surname: inchdto.Surname,
                    FNTG: inchdto.FNTG,
                    SNTG: inchdto.SNTG,
                    FH: inchdto.FH,
                    FHName: inchdto.FHName,
                    VoterID: inchdto.VoterID,
                    GENDER: inchdto.GENDER,
                    AGE: inchdto.AGE,
                    DOB: inchdto.DOB,
                    VillageID: inchdto.VillageID,
                    Caste: inchdto.Caste,
                    LocalNonLocal: inchdto.LocalNonLocal,
                    NL_Remarks: inchdto.NL_Remarks,
                    MOBILE_NO: inchdto.MOBILE_NO,
                    RequestedSchemes: inchdto.RequestedSchemes,
                    Party:inchdto.Party,
                    Remarks:inchdto.Remarks,
                    FamilyCount: inchdto.FamilyCount,
                    InchargeUserid: inchdto.InchargeUserid,
                    UpdatedBy: inchdto.UpdatedBy,
                    GeoLocation: inchdto.GeoLocation,
                    IsHOH:inchdto.IsHOH,
                    ImageLocation: inchdto.ImageLocation
                }
                if(queryParams.apiVersion == 1) {
                    const inchrg = await this.inchrgRepo.update(inchdto.Id,sadata);

                    if(inchrg) {
                        if(inchdto.BenefitsIDs) {
                            await this.benftxrfRepo.delete({InchargeID:inchdto.Id});
                            
                            var benxref = inchdto.BenefitsIDs.split(',').map(async(el) => {
                                
                                await this.benftxrfRepo.save({
                                    BenefitsID: parseInt(el),
                                    InchargeID: inchdto.Id
                                });
                            }); 
                        }
                        
                        if(inchdto.ChildInchargeIds) {
                            await this.inchrgxrfRepo.delete({InchargeID:inchdto.Id});
                            inchdto.ChildInchargeIds.split(',').map(async(el) => {
                                await this.inchrgxrfRepo.save({
                                    InchargeID: inchdto.Id,
                                    InchargeChID: el,
                                    UpdatedBy:inchdto.UpdatedBy
                                });
                            });                        
                        } 
                        
                        response.status = true;
                        response.data = inchrg;
                        response.statusCode = 50000;
                        response.internalMessage = 'Data updated successfully';
                        response.intlCode = 11108;
                    } else {
                        throw new ErrorResponse(99998, 'Failed to modify');
                    }
                                
                } else {
                    const inchrg = await this.inchrgRepo.update(inchdto.Id,sadata);

                    if(inchrg) {
                        if(inchdto.BenefitsIDs) {
                            await this.benftxrfRepo.delete({InchargeID:inchdto.Id});
                            
                            var benxref = inchdto.BenefitsIDs.split(',').map(async(el) => {
                                
                                await this.benftxrfRepo.save({
                                    BenefitsID: parseInt(el),
                                    InchargeID: inchdto.Id
                                });
                            }); 
                        }
                        
                        if(inchdto.ChildInchargeIds) {
                            await this.inchrgxrfRepo.delete({InchargeID:inchdto.Id});
                            inchdto.ChildInchargeIds.split(',').map(async(el) => {
                                await this.inchrgxrfRepo.save({
                                    InchargeID: inchdto.Id,
                                    InchargeChID: el,
                                    UpdatedBy:inchdto.UpdatedBy
                                });
                            });                        
                        } 
                        
                        response.status = true;
                        response.data = inchrg;
                        response.statusCode = 50000;
                        response.internalMessage = 'Data updated successfully';
                        response.intlCode = 11108;
                    } else {
                        throw new ErrorResponse(99998, 'Failed to modify');
                    }
                                
                }
            } else {
                throw new ErrorResponse(99998, 'BoothNo not assigned to this Incharge');
            }
            return response;
        } catch (error) {
            throw error;
        }
    }


    async getInchargeById(queryParams, Id, request:Request): Promise<SingleResponseModel> {
        const response = new SingleResponseModel();
        try {
            if(queryParams.apiVersion == 1) {
                const savedData = await this.inchrgRepo.findOne({ 
                    where:{Id:Id}
                });
                if(savedData) {
                    const benefs = await this.benftxrfRepo.find({
                        relations:['benefit'],
                        where:{InchargeID:savedData.Id}
                    }) 
                    
                    
                    const childs = await this.inchrgxrfRepo.find({
                        where:{InchargeID:Id}
                    });
                    let final = {
                        Id: savedData.Id,
                        BoothNo:savedData.BoothNo,
                        SerialNo: savedData.SerialNo,
                        HNo: savedData.HNo,
                        FirstName: savedData.FirstName,
                        Surname: savedData.Surname,
                        FNTG: savedData.FNTG,
                        SNTG: savedData.SNTG,
                        FH: savedData.FH,
                        FHName: savedData.FHName,
                        VoterID: savedData.VoterID,
                        GENDER: savedData.GENDER,
                        AGE: savedData.AGE,
                        DOB: savedData.DOB,
                        VillageID: savedData.VillageID,
                        Caste: savedData.Caste,
                        LocalNonLocal: savedData.LocalNonLocal,
                        NL_Remarks: savedData.NL_Remarks,
                        MOBILE_NO: savedData.MOBILE_NO,
                        RequestedSchemes: savedData.RequestedSchemes,
                        Party:savedData.Party,
                        Remarks:savedData.Remarks,
                        FamilyCount: savedData.FamilyCount,
                        InchargeUserid: savedData.InchargeUserid,
                        InchargeChildIds:childs,
                        Benefits: benefs,
                        GeoLocation:savedData.GeoLocation,
                        IsHOH:savedData.IsHOH,
                        Image:savedData.ImageLocation.length > 0 ? `${process.env.WORKINGURL}/${savedData.ImageLocation}` : ''
                    }
                    response.status = true;
                    response.data = final;
                    response.statusCode = 50000;
                    response.internalMessage = 'Data retrieved successfully';
                    response.intlCode = 11108;
                } else {
                    throw new ErrorResponse(99998, 'Data not found');
                }
            } else {
                const savedData = await this.inchrgRepo.findOne({ 
                    where:{Id:Id}
                });
                if(savedData) {
                    const benefs = await this.benftxrfRepo.find({
                        relations:['benefit'],
                        where:{InchargeID:savedData.Id}
                    }) 
                    
                    
                    const childs = await this.inchrgxrfRepo.find({
                        where:{InchargeID:Id}
                    });
                    let final = {
                        Id: savedData.Id,
                        BoothNo:savedData.BoothNo,
                        SerialNo: savedData.SerialNo,
                        HNo: savedData.HNo,
                        FirstName: savedData.FirstName,
                        Surname: savedData.Surname,
                        FNTG: savedData.FNTG,
                        SNTG: savedData.SNTG,
                        FH: savedData.FH,
                        FHName: savedData.FHName,
                        VoterID: savedData.VoterID,
                        GENDER: savedData.GENDER,
                        AGE: savedData.AGE,
                        DOB: savedData.DOB,
                        VillageID: savedData.VillageID,
                        Caste: savedData.Caste,
                        LocalNonLocal: savedData.LocalNonLocal,
                        NL_Remarks: savedData.NL_Remarks,
                        MOBILE_NO: savedData.MOBILE_NO,
                        RequestedSchemes: savedData.RequestedSchemes,
                        Party:savedData.Party,
                        Remarks:savedData.Remarks,
                        FamilyCount: savedData.FamilyCount,
                        InchargeUserid: savedData.InchargeUserid,
                        InchargeChildIds:childs,
                        Benefits: benefs,
                        GeoLocation:savedData.GeoLocation,
                        IsHOH:savedData.IsHOH,
                        Image:savedData.ImageLocation.length > 0 ? `${process.env.WORKINGURL}/${savedData.ImageLocation}` : ''
                    }
                    response.status = true;
                    response.data = final;
                    response.statusCode = 50000;
                    response.internalMessage = 'Data retrieved successfully';
                    response.intlCode = 11108;
                } else {
                    throw new ErrorResponse(99998, 'Data not found');
                }
            }
            return response;
        } catch (error) {
            throw error;
        }
    }


    async getAllIncharges(pagDto:PaginationDto, userId, request:Request): Promise<AllResponseModel> {
        const response = new AllResponseModel();
        try {
            const finData: any[] = [];
            var conary: any[] = [];
            if(pagDto.apiVersion == 1) {
                let cond;
                //conary.push({1:1});
                if(pagDto.VillageID) {
                    cond = {VillageID:pagDto.VillageID};
                    conary.push(cond);
                }

                if(pagDto.BoothNo) {
                    cond = {BoothNo:pagDto.BoothNo};
                    conary.push(cond);
                }

                if(pagDto.SerialNo) {
                    cond = {SerialNo:pagDto.SerialNo};
                    conary.push(cond);
                }

                if(pagDto.FirstName) {
                    cond = {FirstName:pagDto.FirstName};
                    conary.push(cond);
                }

                if(pagDto.VoterID) {
                    cond = {VoterID:pagDto.VoterID};
                    conary.push(cond);
                }

                if(pagDto.HNo) {
                    cond = {HNo:pagDto.HNo};
                    conary.push(cond);
                }
                     


                /* if(pagDto.VillageID && pagDto.BoothNo && pagDto.SerialNo) {
                    var inData = await this.inchrgRepo.find({
                        where: [{VillageID:pagDto.VillageID,
                        BoothNo:pagDto.BoothNo,
                        SerialNo:pagDto.SerialNo}],
                        skip:pagDto.skip,
                        take:10
                    })
                } else if(pagDto.VillageID && pagDto.BoothNo) {
                    var inData = await this.inchrgRepo.find({
                        where: [{VillageID:pagDto.VillageID,
                        BoothNo:pagDto.BoothNo}],
                        skip:pagDto.skip,
                        take:10
                    })
                } else if(pagDto.VillageID && pagDto.SerialNo) {
                    var inData = await this.inchrgRepo.find({
                        where: [{VillageID:pagDto.VillageID,
                        SerialNo:pagDto.SerialNo}],
                        skip:pagDto.skip,
                        take:10
                    })
                } else if(pagDto.BoothNo && pagDto.SerialNo) {
                    var inData = await this.inchrgRepo.find({
                        where: [{BoothNo:pagDto.BoothNo,
                        SerialNo:pagDto.SerialNo}],
                        skip:pagDto.skip,
                        take:10
                    })
                } else if(pagDto.VillageID) {
                    var inData = await this.inchrgRepo.find({
                        where: [{VillageID:pagDto.VillageID}],
                        skip:pagDto.skip,
                        take:10
                    })
                }else if(pagDto.BoothNo) {
                    var inData = await this.inchrgRepo.find({
                        where: [{
                        BoothNo:pagDto.BoothNo}],
                        skip:pagDto.skip,
                        take:10
                    })
                }else if(pagDto.SerialNo) {
                    var inData = await this.inchrgRepo.find({
                        where: [{SerialNo:pagDto.SerialNo}],
                        skip:pagDto.skip,
                        take:10
                    })
                } else { 
                    var inData = await this.inchrgRepo.find({
                        skip:pagDto.skip,
                        take:10
                    })
                }*/
                console.log('qry',conary);
                if(conary.length > 1) {
                    var inData = await this.inchrgRepo.find({
                        where: conary,
                        skip:pagDto.skip,
                        take:10
                    })
                } else {
                    var inData = await this.inchrgRepo.find({
                        skip:pagDto.skip,
                        take:10
                    })
                }
                console.log('data',inData);
                if(inData) {
                    const promises = inData.map(async (inchr) => {
                        const benefits = await this.benftxrfRepo.find({
                            relations:['benefit'],
                            where:{InchargeID:inchr.Id}
                        }) 
                        const childs = await this.inchrgxrfRepo.find({
                            where:{InchargeID:inchr.Id}
                        });
                        /* let benlist = benefits.map((b) => {
                            return {
                                BenefitsID: b.BenefitsID,
                                BenefitName: b.benefit
                            }
                        })  */                      
                        return {
                            Id: inchr.Id,
                            BoothNo:inchr.BoothNo,
                            SerialNo: inchr.SerialNo,
                            HNo: inchr.HNo,
                            FirstName: inchr.FirstName,
                            Surname: inchr.Surname,
                            FNTG: inchr.FNTG,
                            SNTG: inchr.SNTG,
                            FH: inchr.FH,
                            FHName: inchr.FHName,
                            VoterID: inchr.VoterID,
                            GENDER: inchr.GENDER,
                            AGE: inchr.AGE,
                            DOB: inchr.DOB,
                            VillageID: inchr.VillageID,
                            Caste: inchr.Caste,
                            LocalNonLocal: inchr.LocalNonLocal,
                            NL_Remarks: inchr.NL_Remarks,
                            MOBILE_NO: inchr.MOBILE_NO,
                            RequestedSchemes: inchr.RequestedSchemes,
                            Party:inchr.Party,
                            Remarks:inchr.Remarks,
                            FamilyCount: inchr.FamilyCount,
                            InchargeUserid: inchr.InchargeUserid,
                            Benefits: benefits,
                            InchargeChildIds:childs,
                            GeoLocation:inchr.GeoLocation,
                            IsHOH:inchr.IsHOH,
                            Image:inchr.ImageLocation != null ? `${process.env.WORKINGURL}/${inchr.ImageLocation}` : ''
                        }
                    })
                    const da = await Promise.all(promises);
                    da.map((inchr) => {  
                        
                        finData.push({
                            Id: inchr.Id,
                            BoothNo:inchr.BoothNo,
                            SerialNo: inchr.SerialNo,
                            HNo: inchr.HNo,
                            FirstName: inchr.FirstName,
                            Surname: inchr.Surname,
                            FNTG: inchr.FNTG,
                            SNTG: inchr.SNTG,
                            FH: inchr.FH,
                            FHName: inchr.FHName,
                            VoterID: inchr.VoterID,
                            GENDER: inchr.GENDER,
                            AGE: inchr.AGE,
                            DOB: inchr.DOB,
                            VillageID: inchr.VillageID,
                            Caste: inchr.Caste,
                            LocalNonLocal: inchr.LocalNonLocal,
                            NL_Remarks: inchr.NL_Remarks,
                            MOBILE_NO: inchr.MOBILE_NO,
                            RequestedSchemes: inchr.RequestedSchemes,
                            Party:inchr.Party,
                            Remarks:inchr.Remarks,
                            FamilyCount: inchr.FamilyCount,
                            InchargeUserid: inchr.InchargeUserid,
                            Benefits: inchr.Benefits,
                            InchargeChildIds: inchr.InchargeChildIds,
                            GeoLocation: inchr.GeoLocation,
                            IsHOH:inchr.IsHOH,
                            Image: inchr.Image
                        })
                        
                    }); 
                    response.status = true;
                    response.data = finData;
                    response.statusCode = 50000;
                    response.internalMessage = 'Data retrieved successfully';
                    response.intlCode = 11108;
                } else {
                    throw new ErrorResponse(99998, 'Data not found');
                }
            } else {
                let cond;
                //conary.push({1:1});
                if(pagDto.VillageID) {
                    cond = {VillageID:pagDto.VillageID};
                    conary.push(cond);
                }

                if(pagDto.BoothNo) {
                    cond = {BoothNo:pagDto.BoothNo};
                    conary.push(cond);
                }

                if(pagDto.SerialNo) {
                    cond = {SerialNo:pagDto.SerialNo};
                    conary.push(cond);
                }

                if(pagDto.FirstName) {
                    cond = {FirstName:pagDto.FirstName};
                    conary.push(cond);
                }

                if(pagDto.VoterID) {
                    cond = {VoterID:pagDto.VoterID};
                    conary.push(cond);
                }

                if(pagDto.HNo) {
                    cond = {HNo:pagDto.HNo};
                    conary.push(cond);
                }
                     


                /* if(pagDto.VillageID && pagDto.BoothNo && pagDto.SerialNo) {
                    var inData = await this.inchrgRepo.find({
                        where: [{VillageID:pagDto.VillageID,
                        BoothNo:pagDto.BoothNo,
                        SerialNo:pagDto.SerialNo}],
                        skip:pagDto.skip,
                        take:10
                    })
                } else if(pagDto.VillageID && pagDto.BoothNo) {
                    var inData = await this.inchrgRepo.find({
                        where: [{VillageID:pagDto.VillageID,
                        BoothNo:pagDto.BoothNo}],
                        skip:pagDto.skip,
                        take:10
                    })
                } else if(pagDto.VillageID && pagDto.SerialNo) {
                    var inData = await this.inchrgRepo.find({
                        where: [{VillageID:pagDto.VillageID,
                        SerialNo:pagDto.SerialNo}],
                        skip:pagDto.skip,
                        take:10
                    })
                } else if(pagDto.BoothNo && pagDto.SerialNo) {
                    var inData = await this.inchrgRepo.find({
                        where: [{BoothNo:pagDto.BoothNo,
                        SerialNo:pagDto.SerialNo}],
                        skip:pagDto.skip,
                        take:10
                    })
                } else if(pagDto.VillageID) {
                    var inData = await this.inchrgRepo.find({
                        where: [{VillageID:pagDto.VillageID}],
                        skip:pagDto.skip,
                        take:10
                    })
                }else if(pagDto.BoothNo) {
                    var inData = await this.inchrgRepo.find({
                        where: [{
                        BoothNo:pagDto.BoothNo}],
                        skip:pagDto.skip,
                        take:10
                    })
                }else if(pagDto.SerialNo) {
                    var inData = await this.inchrgRepo.find({
                        where: [{SerialNo:pagDto.SerialNo}],
                        skip:pagDto.skip,
                        take:10
                    })
                } else { 
                    var inData = await this.inchrgRepo.find({
                        skip:pagDto.skip,
                        take:10
                    })
                }*/

                console.log('qry',conary);

                if(conary.length > 1) {
                    var inData = await this.inchrgRepo.find({
                        where: conary,
                        skip:pagDto.skip,
                        take:10
                    })
                } else {
                    var inData = await this.inchrgRepo.find({
                        skip:pagDto.skip,
                        take:10
                    })
                }
                if(inData) {
                    const promises = inData.map(async (inchr) => {
                        const benefits = await this.benftxrfRepo.find({
                            relations:['benefit'],
                            where:{InchargeID:inchr.Id}
                        }) 
                        const childs = await this.inchrgxrfRepo.find({
                            where:{InchargeID:inchr.Id}
                        });
                        /* let benlist = benefits.map((b) => {
                            return {
                                BenefitsID: b.BenefitsID,
                                BenefitName: b.benefit
                            }
                        })  */                      
                        return {
                            Id: inchr.Id,
                            BoothNo:inchr.BoothNo,
                            SerialNo: inchr.SerialNo,
                            HNo: inchr.HNo,
                            FirstName: inchr.FirstName,
                            Surname: inchr.Surname,
                            FNTG: inchr.FNTG,
                            SNTG: inchr.SNTG,
                            FH: inchr.FH,
                            FHName: inchr.FHName,
                            VoterID: inchr.VoterID,
                            GENDER: inchr.GENDER,
                            AGE: inchr.AGE,
                            DOB: inchr.DOB,
                            VillageID: inchr.VillageID,
                            Caste: inchr.Caste,
                            LocalNonLocal: inchr.LocalNonLocal,
                            NL_Remarks: inchr.NL_Remarks,
                            MOBILE_NO: inchr.MOBILE_NO,
                            RequestedSchemes: inchr.RequestedSchemes,
                            Party:inchr.Party,
                            Remarks:inchr.Remarks,
                            FamilyCount: inchr.FamilyCount,
                            InchargeUserid: inchr.InchargeUserid,
                            Benefits: benefits,
                            InchargeChildIds:childs,
                            GeoLocation:inchr.GeoLocation,
                            IsHOH:inchr.IsHOH,
                            Image:inchr.ImageLocation != null ? `${process.env.WORKINGURL}/${inchr.ImageLocation}` : ''
                            
                        }
                    })
                    const da = await Promise.all(promises);
                    da.map((inchr) => {  
                        
                        finData.push({
                            Id: inchr.Id,
                            BoothNo:inchr.BoothNo,
                            SerialNo: inchr.SerialNo,
                            HNo: inchr.HNo,
                            FirstName: inchr.FirstName,
                            Surname: inchr.Surname,
                            FNTG: inchr.FNTG,
                            SNTG: inchr.SNTG,
                            FH: inchr.FH,
                            FHName: inchr.FHName,
                            VoterID: inchr.VoterID,
                            GENDER: inchr.GENDER,
                            AGE: inchr.AGE,
                            DOB: inchr.DOB,
                            VillageID: inchr.VillageID,
                            Caste: inchr.Caste,
                            LocalNonLocal: inchr.LocalNonLocal,
                            NL_Remarks: inchr.NL_Remarks,
                            MOBILE_NO: inchr.MOBILE_NO,
                            RequestedSchemes: inchr.RequestedSchemes,
                            Party:inchr.Party,
                            Remarks:inchr.Remarks,
                            FamilyCount: inchr.FamilyCount,
                            InchargeUserid: inchr.InchargeUserid,
                            Benefits: inchr.Benefits,
                            InchargeChildIds: inchr.InchargeChildIds,
                            GeoLocation: inchr.GeoLocation,
                            IsHOH:inchr.IsHOH,
                            Image: inchr.Image
                        })
                        
                    }); 
                    response.status = true;
                    response.data = finData;
                    response.statusCode = 50000;
                    response.internalMessage = 'Data retrieved successfully';
                    response.intlCode = 11108;
                } else {
                    throw new ErrorResponse(99998, 'Data not found');
                }
            }
            return response;
        } catch (error) {
            throw error;
        }
    }


    async transformIncharge(trsDto:TransformDto, request:Request): Promise<SingleResponseModel> {
        const response = new SingleResponseModel();
        try {
            if(trsDto.apiVersion == 1) { 
                const updatd = await this.inchrgRepo.update(trsDto.Inchargeid,{InchargeUserid:trsDto.InchargeUserid});
                if(updatd) {
                    response.status = true;
                    response.data   = updatd;
                    response.statusCode = 50000;
                    response.internalMessage = 'Post Edited Successfully';
                    response.intlCode = 11100;  
                }  else {
                    throw new ErrorResponse(99998, 'event update failed')
                }

            } else {
                const updatd = await this.inchrgRepo.update(trsDto.Inchargeid,{InchargeUserid:trsDto.InchargeUserid});
                if(updatd) {
                    response.status = true;
                    response.data   = updatd;
                    response.statusCode = 50000;
                    response.internalMessage = 'Post Edited Successfully';
                    response.intlCode = 11100;  
                }  else {
                    throw new ErrorResponse(99998, 'event update failed')
                }
            }
            return response;
        } catch (error) {
            throw error;
        }
    }


    async editChildIncharges(queryParams,inchdto:ChildInchargeDto,request:Request): Promise<SingleResponseModel> {
        const response = new SingleResponseModel();
        try {
            if(queryParams.apiVersion == 1) {
                if(inchdto.ChildInchargeIds) {
                    inchdto.ChildInchargeIds.split(',').map(async(el) => {
                        await this.inchrgxrfRepo.save({
                            InchargeID: inchdto.Inchargeid,
                            InchargeChID: el,
                            Createdby:inchdto.Createdby
                        });
                    });                        
                }            
                    
                response.status = true;
                response.statusCode = 50000;
                response.internalMessage = 'Data saved successfully';                
                            
            } else {
                if(inchdto.ChildInchargeIds) {
                    inchdto.ChildInchargeIds.split(',').map(async(el) => {
                        await this.inchrgxrfRepo.save({
                            InchargeID: inchdto.Inchargeid,
                            InchargeChID: el,
                            Createdby:inchdto.Createdby
                        });
                    });                        
                }            
                    
                response.status = true;
                response.statusCode = 50000;
                response.internalMessage = 'Data saved successfully';       
            }
            return response;
        } catch (error) {
            throw error;
        }
    }
}
